import { createPageUrl } from '@/utils';
import {
  SELECTIVE_PRIMARY_NAV_ITEMS,
  resolveSelectiveNavigationRoute,
} from '@/lib/selectiveNavigationContract.js';

export const HEADER_NAV_ICON_IDS = Object.freeze({
  HOME: 'home',
  GAMES: 'games',
  DEAL_FINDER: 'deal-finder',
  DASHBOARD: 'dashboard',
  LIVE: 'live',
  NEWS: 'news',
  SUPPORT: 'support',
  PRICING: 'pricing',
  DATA_MANAGER: 'data-manager',
});

const FULL_NAV_ITEMS = Object.freeze([
  Object.freeze({
    id: 'games',
    href: '/games',
    labelKey: 'nav.games',
    iconId: HEADER_NAV_ICON_IDS.GAMES,
  }),
  Object.freeze({
    id: 'deal-finder',
    href: '/deal-finder',
    labelKey: 'nav.deal_finder',
    iconId: HEADER_NAV_ICON_IDS.DEAL_FINDER,
    requiresDealFinderAccess: true,
  }),
  Object.freeze({
    id: 'dashboard',
    href: '/dashboard',
    labelKey: 'nav.dashboard',
    iconId: HEADER_NAV_ICON_IDS.DASHBOARD,
  }),
  Object.freeze({
    id: 'live',
    href: '/live',
    labelKey: 'nav.live',
    iconId: HEADER_NAV_ICON_IDS.LIVE,
  }),
  Object.freeze({
    id: 'news',
    href: '/news',
    labelKey: 'nav.news',
    iconId: HEADER_NAV_ICON_IDS.NEWS,
  }),
  Object.freeze({
    id: 'support',
    href: '/support',
    labelKey: 'nav.support',
    iconId: HEADER_NAV_ICON_IDS.SUPPORT,
  }),
  Object.freeze({
    id: 'pricing',
    href: '/pricing',
    labelKey: 'nav.pricing',
    iconId: HEADER_NAV_ICON_IDS.PRICING,
  }),
  Object.freeze({
    id: 'data-manager',
    href: '/gamedatamanager',
    labelKey: 'nav.data_manager',
    iconId: HEADER_NAV_ICON_IDS.DATA_MANAGER,
    requiresAdmin: true,
  }),
]);

const SELECTIVE_ICON_BY_ITEM_ID = Object.freeze({
  home: HEADER_NAV_ICON_IDS.HOME,
  games: HEADER_NAV_ICON_IDS.GAMES,
  'deal-finder': HEADER_NAV_ICON_IDS.DEAL_FINDER,
  news: HEADER_NAV_ICON_IDS.NEWS,
  support: HEADER_NAV_ICON_IDS.SUPPORT,
});

const translateItem = (item, translate) => ({
  ...item,
  name: translate(item.labelKey),
});

export const buildLayoutNavigationItems = ({
  isSelectivePublicNavigation = false,
  isAdmin = false,
  canAccessDealFinder = false,
  translate = (key) => key,
} = {}) => {
  if (isSelectivePublicNavigation) {
    return SELECTIVE_PRIMARY_NAV_ITEMS.map((item) =>
      translateItem(
        {
          ...item,
          iconId: SELECTIVE_ICON_BY_ITEM_ID[item.id],
        },
        translate,
      ),
    );
  }

  return FULL_NAV_ITEMS.filter((item) => {
    if (item.requiresAdmin && !isAdmin) {
      return false;
    }
    if (item.requiresDealFinderAccess && !canAccessDealFinder) {
      return false;
    }
    return true;
  }).map((item) => translateItem(item, translate));
};

export const resolveLayoutActiveNavHref = ({
  pathname,
  isSelectivePublicNavigation = false,
} = {}) => {
  if (isSelectivePublicNavigation) {
    return resolveSelectiveNavigationRoute(pathname).activeHref;
  }

  const currentPageName = pathname?.split('/').pop() || 'Landing';
  return createPageUrl(currentPageName);
};
